import { render, staticRenderFns } from "./BlockContainer.vue?vue&type=template&id=4b6d6403&scoped=true&"
import script from "./BlockContainer.vue?vue&type=script&lang=ts&"
export * from "./BlockContainer.vue?vue&type=script&lang=ts&"
import style0 from "./BlockContainer.vue?vue&type=style&index=0&id=4b6d6403&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6d6403",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
